import { AbstractControl, ValidationErrors } from '@angular/forms';

export function guidValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }
  
  const guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  const isValid = guidPattern.test(control.value);
  return isValid ? null : { invalidGuid: true };
}
